module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ruth, his wife, his delightful wife, was in the kitchen. Ah, bless her, the wee bundle of joy, she’d changed her clothes. She was sitting at the table, slouched over like she was suffering from stomach cramp, a mug of tea cradled in the bosom of her black dress. Man, could she suffer. Her eyes were crimson. She didn’t look up at him. Scattered on the table in front of her were half-a-dozen travel brochures. Joe could make out the covers of only three: Andalusia, Morocco, Tunisia. Her favourite holiday locations. Time to run away, was it? Her daughter was dead and Ruth was planning a holiday. She never faced anything. Fuck. Give her a break, you twat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He dragged out a chair, sat down opposite her and tried to be kind. His tongue felt thick. ‘You shouldn’t be on your own.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly, she lifted the mug to her mouth. She slurped, gasped, set down the mug. Her gaze drifted towards him. ‘You’re so considerate.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waited a moment, then said, ‘What happened to Gem?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes held his for a couple of seconds. Then she looked into her mug. ‘I don’t believe you.’ She lowered her head and he noticed she was developing a cracker of a bald patch at the crown. Her head jerked upright. Spit flew out of her mouth when she said, ‘I don’t fucking believe you.’ Her face was screwed up, old, ugly. ‘You’re a fucking’ – her hands flew into the air, fingers spread – ‘bastard, Joe.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He put his head in his hands and rubbed his eyes. When he took his hands away the overhead light seemed unnaturally bright. He looked up at it and winced. When he looked back down again she was staring at him, her upper lip curled. Her face was still old and ugly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She said through quivering lips, ‘Don’t you care that your daughter’s dead?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("‘I’m asking,’ he said. ‘What happened?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ve got a cheek. You know it’s your fault.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He waited a moment. ‘I was nowhere near her. How can it have been my fault?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She left because of you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bollocks.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why do you think she left, then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stood up. ‘I don’t have to listen to this shit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You wish, Joe. You fucking wish.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean, she left because of me?’ He sat down again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She was unhappy. You didn’t talk to her about it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I would have.’ He ran his hand through his hair. It felt thin, more like Ruth’s every day. ‘I would have. What do you mean? Talked to her about what? The fuck’re you on about? I didn’t know she wanted to talk. She didn’t say anything.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How could you not know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tapped his fingers against his brow. ‘Why – why didn’t she say? Why didn’t you tell me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why do you think she left university? Why do you think she left home and went to live on some godforsaken island with a relative she hardly knows?’ Saliva gathered at the edges of her mouth. ‘Because she was happy?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe turned away. ‘What was upsetting her?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know.’ Ruth squeezed her mug between her hands. ‘Something happened. She wouldn’t tell me what.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She wouldn’t have—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She would. You fucking dumb bastard. You know she would have told you anything.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If she didn’t tell you—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Joe, she loved you.’ Ruth banged her fist against her heart. ‘God knows why, but she loved you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He felt as if all the blood had drained from his body. ‘Why "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("didn’t she say something? If there was a problem.’ He swallowed. ‘She should have said.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You never asked.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t know. Fucking hell. I didn’t know anything was wrong. Why would I ask?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You should have.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, I fucking didn’t, you dozy bitch. How many times do I have to tell you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you’d fucking paid attention, maybe she wouldn’t be dead.’ Ruth jumped to her feet and slung the mug at him. It missed, crashed into the cooker behind him and exploded. The side of his face was wet. He stretched his tongue towards his cheek. Cold, strong, black tea. Veins of dark brown liquid trailed across the pine table, bunching at the bottom edge of Ruth’s travel brochure for Morocco. He looked sideways at the floor. Puddles of tea swelled on the linoleum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Was that a full cup?’ he asked. ‘Or don’t I deserve that much wastage?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her shoulders rocked up and down, the only indication that she might be laughing. Of course, she might equally be crying. ‘Actually,’ she said, ‘I’d drunk hardly any of it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He still couldn’t determine her mood. Nothing new there. Now she was staring at her fidgeting hands. He wiped his cheek with his palm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I saw this TV programme once.’ She looked at him, eyes shiny. ‘This woman lost her daughter. Car accident. She said her biggest fear was that she’d never stop crying.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe waited. Finally he said, ‘What are you trying to say?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Never mind.’ She lowered her head. ‘You weren’t there for Gemma.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What was I supposed to do?’ Joe stamped his foot and was annoyed with himself at the childishness of his gesture. He "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("grunted, steadied himself. ‘I didn’t know anything was wrong.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You could write a book about the things you don’t know.’ She turned her head to the side and stared at the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He bent over and squeezed her chin between his fingers, forcing her to face him. She lowered her eyes. Refused to meet his gaze. Her face was grey, tear-streaked. Quietly, he asked her, ‘What else don’t I know?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m being mean,’ she said, looking at the floor. ‘Take no notice.’ Her jaw moved between his finger and thumb. ‘Shouldn’t be too hard for you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He let go of her. ‘I’m going to Cooper’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fine,’ she said. ‘Off to your boyfriend’s loving arms at the slightest excuse.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fuck your jealous bullshit.’ Joe came very close to hitting his wife. If he stayed any longer he wasn’t sure he’d be able to control himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I assure you I have nothing to be jealous of,’ she said. ‘Believe me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘’Bye, darling,’ he said as he slammed the door.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60956a70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780857901729_10_ch4.vue
// module id = 84
// module chunks = 0